import styled from 'styled-components'

const StyledLessonView = styled.div`
  .lesson-top-bar {
    display: flex;
    justify-content: space-between;

    .back-btn {
      margin-left: -15px;
      font-size: 0;
    }

    .completion-bar {
      pointer-events: none;
      display: none;
      width: 100%;
      grid-gap: 7px;
      margin-right: 1rem;
      min-width: 250px;

      label {
        font-weight: 400;
        font-size: 15px;
        letter-spacing: 0.1px;
        text-align: right;
        color: ${({ theme }) => theme.colors.gray[500]};
        font-family: ${({ theme }) => theme.fonts.lexend};
      }

      progress {
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        height: 8px;
        border-radius: 50rem;
        overflow: hidden;

        &::-webkit-progress-bar {
          background: ${({ theme }) => theme.colors.gray[100]};
        }

        &::-webkit-progress-value {
          border-radius: 50rem;
          background: ${({ theme }) => theme.colors.green[300]};
          transition: 0.2s;
        }
      }
    }
  }

  .width-controller {
    padding: 20px 20px 60px 20px;
    transition: max-width 0.2s;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .lesson-top-bar {
      .completion-bar {
        display: grid;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .lesson-top-bar {
      .back-btn {
        font-size: 15px;
      }
    }
  }
`

export default StyledLessonView
